import { render, staticRenderFns } from "./FieldStorage.vue?vue&type=template&id=af4ed02a&scoped=true"
import script from "./FieldStorage.vue?vue&type=script&lang=js"
export * from "./FieldStorage.vue?vue&type=script&lang=js"
import style0 from "./FieldStorage.vue?vue&type=style&index=0&id=af4ed02a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4ed02a",
  null
  
)

export default component.exports